import { Routes, Route } from 'react-router-dom';
import { PageLayout } from '../components/PageLayout';
import ProtectedRoute from '../components/ProtectedRoute';
import GuestRoute from '../components/GuestRoute';
import HomePage from '../pages/HomePage';
import GameDetailPage from '../pages/GameDetailPage';
import GamesPage from '../pages/GamesPage';
import TagPage from '../pages/TagPage';
import CompanyPage from '../pages/CompanyPage';
import AboutPage from '../pages/AboutPage';
import PrivacyPage from '../pages/PrivacyPage';
import TermsPage from '../pages/TermsPage';
import SignupPage from '../pages/SignupPage';
import SigninPage from '../pages/SigninPage';
import ProfilePage from '../pages/ProfilePage';
import FavoritesPage from '../pages/FavoritesPage';
import backgroundImage from '../assets/goblin.jpg';
import backgroundImage2 from '../assets/bacground2.jpeg';


export const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<PageLayout backgroundImage={backgroundImage} />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/games" element={<GamesPage />} />
        <Route path="/tags/:tag" element={<TagPage />} />
        <Route path="/company/:role/:name" element={<CompanyPage />} />
        <Route path="/about" element={<AboutPage />} />
  <Route path="/privacy" element={<PrivacyPage />} />
  <Route path="/terms" element={<TermsPage />} />
        <Route
          path="/auth/signup"
          element={
            <GuestRoute>
              <SignupPage />
            </GuestRoute>
          }
        />
        <Route
          path="/auth/signin"
          element={
            <GuestRoute>
              <SigninPage />
            </GuestRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/favorites"
          element={
            <ProtectedRoute>
              <FavoritesPage />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route element={<PageLayout backgroundImage={backgroundImage} />}>
        <Route path="/game/:id" element={<GameDetailPage />} />
      </Route>
       <Route element={<PageLayout backgroundImage={backgroundImage} />}>
        <Route path="*" element={<HomePage />} />
      </Route>
    </Routes>
  );
};